import * as React from "react";

function CreditCardFace(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.818 4h18.364C22.186 4 23 4.895 23 6v12c0 1.105-.814 2-1.818 2H2.818C1.814 20 1 19.105 1 18V6c0-1.105.814-2 1.818-2zM3 6v12h18V6H3zm2 8v2h2v-2H5zm3 2v-2h3v2H8zm9-2v2h2v-2h-2zm-3 2v-2h2v2h-2zM8 9H5v3h3V9z"
      />
    </svg>
  );
}

export default CreditCardFace;
